import React from 'react';

export default function ScheduleTiersCard({ scheduleTiers, presets, onPresetChange, onEditClick }) {
  const tiers = [
    { key: 'tier_1', label: 'Tier 1', data: scheduleTiers?.tier_1 },
    { key: 'tier_2', label: 'Tier 2', data: scheduleTiers?.tier_2 },
    { key: 'tier_3', label: 'Tier 3', data: scheduleTiers?.tier_3 },
    { key: 'tier_4', label: 'Tier 4', data: scheduleTiers?.tier_4 },
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Schedule Tiers</h3>
        <div className="flex items-center gap-2">
          <select
            value={scheduleTiers?.preset || 'default'}
            onChange={(e) => onPresetChange(e.target.value)}
            className="text-sm border rounded px-2 py-1"
          >
            {presets && Object.entries(presets).map(([key, preset]) => (
              <option key={key} value={key}>{preset.label}</option>
            ))}
          </select>
          <button
            onClick={onEditClick}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            Edit
          </button>
        </div>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 border-b">
            <th className="pb-2">Tier</th>
            <th className="pb-2">Days Range</th>
            <th className="pb-2">Update Interval</th>
          </tr>
        </thead>
        <tbody>
          {tiers.map(({ key, label, data }) => (
            <tr key={key} className="border-b last:border-0">
              <td className="py-2 font-medium">{label}</td>
              <td className="py-2">{data?.days_start} → {data?.days_end} days</td>
              <td className="py-2">Every {data?.interval_hours}h</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
